/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * assistant: an admin’s private chat; the agent acts as that admin. reviewer: the review of one professional or activity, shared by every admin; the agent acts as the reviewer service account, limited to that entity.
 */
export enum AgentThreadKind {
  assistant = 'assistant',
  reviewer = 'reviewer'
}
